var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphUpArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph-up-arrow",
    clipPath: "url(#clip0_1472_526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.466888H1.5V22.9669H24V24.4669H0V0.466888ZM15 5.71689C15 5.51798 15.079 5.32721 15.2197 5.18656C15.3603 5.04591 15.5511 4.96689 15.75 4.96689H21.75C21.9489 4.96689 22.1397 5.04591 22.2803 5.18656C22.421 5.32721 22.5 5.51798 22.5 5.71689V11.7169C22.5 11.9158 22.421 12.1066 22.2803 12.2472C22.1397 12.3879 21.9489 12.4669 21.75 12.4669C21.5511 12.4669 21.3603 12.3879 21.2197 12.2472C21.079 12.1066 21 11.9158 21 11.7169V7.81689L15.5805 14.4424C15.5142 14.5234 15.4316 14.5896 15.3381 14.6367C15.2447 14.6839 15.1424 14.7109 15.0378 14.7161C14.9332 14.7214 14.8288 14.7046 14.731 14.6671C14.6333 14.6295 14.5446 14.5718 14.4705 14.4979L10.59 10.6174L5.106 18.1579C4.98603 18.3104 4.81161 18.4105 4.61938 18.4372C4.42714 18.4638 4.23207 18.4149 4.07516 18.3007C3.91824 18.1865 3.8117 18.0159 3.77792 17.8248C3.74413 17.6337 3.78574 17.437 3.894 17.2759L9.894 9.02589C9.95769 8.93816 10.0396 8.86528 10.1342 8.81227C10.2288 8.75926 10.3337 8.72738 10.4418 8.71882C10.5498 8.71027 10.6585 8.72525 10.7602 8.76272C10.8619 8.80019 10.9543 8.85927 11.031 8.93589L14.9445 12.8509L20.1675 6.46689H15.75C15.5511 6.46689 15.3603 6.38787 15.2197 6.24722C15.079 6.10657 15 5.9158 15 5.71689Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1472_526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.466888)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphUpArrowBlue);
export default __webpack_public_path__ + "static/media/graph-up-arrow-blue.0978f807ce3ac35a8534cb858af51070.svg";
export { ForwardRef as ReactComponent };